import { useRouter } from 'next/router';
import {
  Bar,
  BarChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import { StyledRecharts } from './Recharts.styled';

const SuccessRole: React.FC = () => {
  const { locale } = useRouter();

  const GRAPH_07_SUCCESS_BY_ROLE = [
    { label: locale === 'es' ? 'Liderazgo Técnico' : 'Tech Lead', value: 76 },
    {
      label: locale === 'es' ? 'Desarrollo Mobile' : 'Mobile Development',
      value: 74
    },
    {
      label: locale === 'es' ? 'Desarrollo Backend' : 'Backend Development',
      value: 72
    },
    {
      label: locale === 'es' ? 'Desarrollo Frontend' : 'Frontend Development',
      value: 72
    },
    {
      label: locale === 'es' ? 'Infraestructura' : 'Infraestructure',
      value: 64
    },
    {
      label: 'Product Management',
      value: 63
    },
    {
      label: 'Engineering Management',
      value: 55
    },
    { label: locale === 'es' ? 'Otros' : 'Other', value: 54 },
    { label: 'QA & Testing', value: 54 },
    { label: 'Data', value: 52 },
    {
      label:
        locale === 'es' ? 'Desarrollo Full-Stack' : 'Full-Stack Development',
      value: 50
    }
  ];

  return (
    <div>
      <StyledRecharts>
        <ResponsiveContainer width="99%" height={360}>
          <BarChart data={GRAPH_07_SUCCESS_BY_ROLE} layout="vertical">
            <XAxis
              type="number"
              allowDecimals={false}
              tickLine={false}
              padding={{ left: 10 }}
              tickFormatter={(tick: number) => {
                return tick + '%';
              }}
            />
            <YAxis
              type="category"
              dataKey="label"
              tickLine={false}
              width={190}
            />
            <Tooltip
              cursor={{ fill: '#e6dfff' }}
              labelStyle={{ display: 'none' }}
              separator=""
              formatter={(value: number) => [value + '%', '']}
              wrapperClassName="tooltip-y"
            />
            <Bar dataKey="value" fill="#472CA6" barSize={12} radius={6} />
          </BarChart>
        </ResponsiveContainer>
      </StyledRecharts>
    </div>
  );
};

export default SuccessRole;
